import { render, staticRenderFns } from "./TableLoadingBody.vue?vue&type=template&id=6785c024"
import script from "./TableLoadingBody.vue?vue&type=script&lang=js"
export * from "./TableLoadingBody.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports